angular.module('components.caImportEditorTextDropdown', [])
    .component('caImportEditorTextDropdown', {
        templateUrl: 'main/product/productimporteditor/components/importeditortextdropdown.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            selectionOptions: '<',
            groupRow: '<',
            editProperty: '<',
            onSelectionChanged: '&',
            onFocus: '&',
            onBlur: '&',
            filterFunction: '<',
            backgroundClass: '<'
        },
        controller: controller
    }); 

// @ngInject
function controller($scope) {
    var vm = this;
    var numberOfResults = 100;

    vm.placeholderModel = {};
    vm.localSelectionOptions = [];

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    vm.selectionChanged = selectionChanged;

    vm.refreshSearchItems = refreshSearchItems;

    vm.dropDownToggled = dropDownToggled;

    function onInit() {
        refreshSearchItems("");
        initializePlaceholderModel();

        $scope.$watch(function() { return vm.groupRow[vm.editProperty]; }, function(oldValue, newValue) {
            if (oldValue !== newValue) {
                vm.placeholderModel.value = vm.groupRow[vm.editProperty];
            }
        });
    }

    function onChanges(changes) {

    }
    function onDestroy() {
    }

    function initializePlaceholderModel(search) {

        vm.placeholderModel = {
            value: vm.groupRow[vm.editProperty],
            fullName: vm.groupRow[vm.editProperty],
            editProperty: vm.editProperty
        };
    }

    function refreshSearchItems(searchTerm) {
        vm.localSelectionOptions = [];
        var splitTerms = searchTerm.split(" ");
        var regexes = [];
        // constructing regex: /.*searchTerm.*/i
        _.forEach(splitTerms, function(term) { regexes.push(new RegExp(".*" + term + ".*", 'i')); });

        var items = vm.selectionOption;

        _.forEach(regexes, function(regex) {
            items = _.filter(vm.selectionOptions, function(selectionOption) { return selectionOption.fullName.search(regex) !== -1; });
        });

        items = vm.filterFunction(items, vm.editProperty, vm.groupRow);
        items = _.take(items, numberOfResults);

        if (items.length === 0 && searchTerm.length > 0) {
            items.unshift({
                value: searchTerm,
                fullName: searchTerm
            });
        }

        vm.localSelectionOptions = items;

        vm.localSelectionOptions.unshift({ value:"",fullName:"" });
    }

    function selectionChanged() {
        vm.onSelectionChanged({groupRow: vm.groupRow, editProperty: vm.editProperty, value: vm.placeholderModel.value});
    }

    function dropDownToggled(isOpen) {
        if (isOpen) {
            vm.onFocus({ propertyName: vm.editProperty, groupRow: vm.groupRow });
        } else {
            vm.onBlur({ propertyName: vm.editProperty, groupRow: vm.groupRow });
        }
    }

}
